import { withInstall } from "../utils/index.mjs";
import _DropdownItem from "./DropdownItem.mjs";
const DropdownItem = withInstall(_DropdownItem);
var stdin_default = DropdownItem;
import { dropdownItemProps } from "./DropdownItem.mjs";
export {
  DropdownItem,
  stdin_default as default,
  dropdownItemProps
};
